import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import "styles/global.scss";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import App from "./App";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";

const sAlert = withReactContent(Swal);
const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  /* eslint-disable no-useless-escape */
  // <React.StrictMode>
  <BrowserRouter>
    <App />
  </BrowserRouter>
  // </React.StrictMode>
);

// برای چک کردن اینکه کلاینت تغییرات جدید را متوجه شود و در صورتیکه تغییرات جدیدی اتفا افتاده باشد بارگذاری اتفاق بیفتد
serviceWorkerRegistration.register({
  onUpdate: (registration) => {
    sAlert.fire({
      title:
        "کاربر گرامی تغییرات جدیدی وجود دارد. برای به روز رسانی مایل هستید؟",
      confirmButtonText: "تایید",
      position: "top",
    });
    if (registration && registration.waiting) {
      registration.waiting.postMessage({ type: "SKIP_WAITING" });
    }
    window.location.reload();
  },
});
